//#region src/common/is-sio-host.ts
function e(e) {
	let t = e.replace(/:\d+$/, "");
	return /^systeme\.(?:io|club|local)$/i.test(t);
}
//#endregion
export { e as isSioHost };
